import { jwtDecode } from 'jwt-decode';

// Funkcija za dobijanje tokena iz localStorage
const getToken = () => {
  return localStorage.getItem('token');
};

// Funkcija za dekodiranje JWT tokena
const decodeToken = () => {
  const token = getToken();
  if (token) {
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Error decoding token', error);
      return null;
    }
  }
  return null;
};

// Funkcija za dobijanje uloge korisnika iz tokena
const getUserRole = () => {
  const decodedToken = decodeToken();
  return decodedToken?.role || null;
};

// Funkcija za proveru da li je korisnik admin
const isAdmin = () => {
  const role = getUserRole();
  return role === '1';
};

// Funkcija za proveru da li je korisnik škola
const isSchool = () => {
  const role = getUserRole();
  return role === '3';
};

// Funkcija za proveru da li je token istekao
const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decoded.exp < currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return true;
  }
};

// Funkcija za odjavu korisnika
const logout = () => {
  localStorage.removeItem('token');
};

export {
  getToken,
  decodeToken,
  getUserRole,
  isAdmin,
  isSchool,
  isTokenExpired,
  logout
};
